export const passwordRules = {
    required: true,
    min: 8,
    capitalLetter: true,
    specialCharacter: true
};
